import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import './App.css';
import FactureeCompPaperExmpl from './pages/FactureeCompPaperExmpl';
import {ThemeProvider} from "@mui/material";
import FactureeBackground from "./standard-mui-examples/surfaces/facturee-background";
import {useThemeStore} from "./stores/themeStore";
import Layout from "./components/Layout";
import FactureeCompNumericInputExmpl from "./pages/FactureeCompNumericInputExmpl";
import FactureeCompModalDialogExmpl from "./pages/FactureeCompModalDialogExmpl";
import FactureeCompUploadExmpl from "./pages/FactureeCompUploadExmpl";
import FactureeCompAccordionExmpl from './pages/FactureeCompAccordionExmpl';
import FactureeCompShortlistExmpl from "./pages/FactureeCompShortlistExmpl";
import FactureeCompModalInfoExmpl from "./pages/FactureeCompModalInfoExmpl";
import FactureeCompStepperExmpl from "./pages/FactureeCompStepperExmpl";
import FactureeMuiElements from "./pages/FactureeMuiElements";
import FaAILoadingIconExmpl from "./pages/FaAILoadingIconExmpl";

function App() {
  const themeStore = useThemeStore();
  return (
      <ThemeProvider theme={themeStore.materialTheme}>
        <FactureeBackground>
          <Router>
            <Routes>
              <Route path='*' element={<Layout/>}>
                <Route path="*" Component={FactureeMuiElements}/>
                <Route path="component-example-accordion" Component={FactureeCompAccordionExmpl}/>
                <Route path="component-example-numeric-input" Component={FactureeCompNumericInputExmpl}/>
                <Route path="component-example-upload" Component={FactureeCompUploadExmpl}/>
                <Route path="component-example-modal-dialog" Component={FactureeCompModalDialogExmpl}/>
                <Route path="component-example-modal-info" Component={FactureeCompModalInfoExmpl}/>
                <Route path="component-example-paper" Component={FactureeCompPaperExmpl}/>
                <Route path="component-example-shortlist" Component={FactureeCompShortlistExmpl}/>
                <Route path="component-example-stepper" Component={FactureeCompStepperExmpl}/>
                <Route path="component-example-ai-loading-icon" Component={FaAILoadingIconExmpl}/>
              </Route>
            </Routes>
          </Router>
        </FactureeBackground>
      </ThemeProvider>
  );
}

export default App;


